import { type ComponentPropsWithoutRef, type ElementRef, type Ref } from 'react';
import { TextArea as HeroTextArea } from '@heroui/react';
import { cn } from '../utils';

type TextareaProps = ComponentPropsWithoutRef<typeof HeroTextArea>;

export const Textarea = ({
  ref,
  className,
  fullWidth = true,
  variant = 'secondary',
  ...props
}: TextareaProps & { ref?: Ref<ElementRef<typeof HeroTextArea>> }) => (
  <HeroTextArea
    ref={ref}
    fullWidth={fullWidth}
    variant={variant}
    className={cn('min-h-24 text-base sm:text-sm', className)}
    {...props}
  />
);

Textarea.displayName = 'Textarea';
export type { TextareaProps };
